import React from 'react';

// Format a backend UTC timestamp to a compact "dd-MM-yy HH:mm"; blank if unparseable.
function fmtWhen(value) {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  const p = (n) => String(n).padStart(2, '0');
  return `${p(d.getDate())}-${p(d.getMonth() + 1)}-${String(d.getFullYear()).slice(2)} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

function previewOf(session) {
  const msgs = session.OpenAiChatMessages;
  if (Array.isArray(msgs) && msgs.length) {
    const last = msgs[msgs.length - 1];
    const text = (last && (last.content || last.Content)) || '';
    if (text) return text.replace(/\*\*|`/g, '');
  }
  return 'No messages yet — say hi';
}

export default function SessionsBlob({ session, isSelected, onSelect }) {
  const name = session.SessionName || 'Unnamed conversation';
  const when = fmtWhen(session.LastUpdatedUtc);
  return (
    <button
      className={'ac-item' + (isSelected ? ' active' : '')}
      onClick={() => onSelect(session.SessionId)}
      title={name}
    >
      <div className='ci-title'>{name}</div>
      <div className='ci-preview'>{previewOf(session)}</div>
      <div className='ci-meta'>
        {when ? <span>{when}</span> : null}
        {when ? <span className='dot' /> : null}
        <span className='id'>#{session.SessionId}</span>
      </div>
    </button>
  );
}
